import { Injectable } from '@angular/core';
import { Subscription } from "rxjs";
import { map,take } from "rxjs/operators";
import { AngularFireFunctions } from '@angular/fire/functions';
import { UserService } from './user.service';
import { BrandingService } from './branding.service';
@Injectable({
  providedIn: 'root'
})
export class ProposalNotificationsService {

  dataSub : Subscription;

  constructor(
    private functions: AngularFireFunctions,
    private userService : UserService,
    private brandingService : BrandingService
  ) {
  }

  notifyOfSign(proposal) {
    const textMessageFunction = this.functions.httpsCallable('textMessage');
    const sendEmailFunction = this.functions.httpsCallable('sendEmail');
    const url = `${window.location.origin}/dartboard/all/${proposal?.meta?.id}`
    this.userService.users$.pipe(
        take(1),
        map( users => users.find(user => user.uid == proposal?.meta?.createdBy))
      ).subscribe( async consultant =>  {
      this.notifyAdminsOfProposalSign(proposal, consultant)
      if (consultant?.phone && !consultant?.isDisableTexts) {
        const ownerNumber = this.formatPhoneNumber(consultant.phone)
        try {
          await textMessageFunction(
            {
              to : ownerNumber,
              body: `UPDATE FROM DARTBID: Customer '${proposal?.info?.firstName || proposal?.info?.lastName ? proposal?.info?.firstName + ' ' + proposal?.info?.lastName : ''}' has signed their proposal.
              
${proposal?.price ? 'Total: ' + proposal?.price.toFixed(2) : ''}

${url ? 'View your proposal here at ' + url : ''}
              `
            }
          ).toPromise()
        } catch(err) {
          console.log(`error: ${err}`)
          return false
        }
      }
      if (consultant?.email && !consultant?.isDisableEmails) {
        try {
          await sendEmailFunction({
          to: consultant.email,
          subject: `Update from Dartbid - Proposal Signed`,
          text: `UPDATE FROM DARTBID: Customer '${proposal?.info?.firstName || proposal?.info?.lastName ? proposal?.info?.firstName + ' ' + proposal?.info?.lastName : ''}' has signed their proposal.

${proposal?.price ? 'Total: ' + proposal?.price.toFixed(2) : ''}

${url ? 'View your proposal here at ' + url : ''}
          `,
          html: `<h2>UPDATE FROM DARTBID</h2>
          <p>Customer '${proposal?.info?.firstName || proposal?.info?.lastName ? proposal?.info?.firstName + ' ' + proposal?.info?.lastName : ''}' has signed their proposal.</p>
          ${proposal?.price ? '<p><strong>Total: $' + proposal?.price.toFixed(2) + '</strong></p>' : ''}
          ${url ? '<p><a href="' + url + '">View your proposal here</a></p>' : ''}
          <p>Please do not reply to this message.</p>
          `
          }).toPromise()
        } catch(err) {
          console.log(`error: ${err}`)
          return false
        }
      }
    })
  }

  notifyOfSignLinked(proposal, total) {
    const textMessageFunction = this.functions.httpsCallable('textMessage');
    const sendEmailFunction = this.functions.httpsCallable('sendEmail');
    const url = `${window.location.origin}/dartboard/all/${proposal?.meta?.id}`

    this.userService.users$.pipe(
        take(1),
        map( users => users.find(user => user.uid == proposal?.meta?.createdBy))
      ).subscribe( async consultant =>  {
      this.notifyAdminsOfLinkedProposalSign(proposal, consultant, total)
      if (consultant?.phone && !consultant?.isDisableTexts) {
        const ownerNumber = this.formatPhoneNumber(consultant.phone)
        try {
          await textMessageFunction(
            {
              to : ownerNumber,
              body: `UPDATE FROM DARTBID: Customer '${proposal?.info?.firstName || proposal?.info?.lastName ? proposal?.info?.firstName + ' ' + proposal?.info?.lastName : ''}' has signed their proposal.
              
${total ? 'Total: ' + total.toFixed(2) : ''}

${url ? 'View your proposal here at ' + url : ''}
              `
            }
          ).toPromise()
        } catch(err) {
          console.log(`error: ${err}`)
          return false
        }
      }
          if (consultant?.email && !consultant?.isDisableEmails) {
        try {
          await sendEmailFunction({
          to: consultant.email,
          subject: `Update from Dartbid - Proposal Signed`,
          text: `UPDATE FROM DARTBID: Customer '${proposal?.info?.firstName || proposal?.info?.lastName ? proposal?.info?.firstName + ' ' + proposal?.info?.lastName : ''}' has signed their proposal.

${proposal?.price ? 'Total: ' + proposal?.price.toFixed(2) : ''}

${url ? 'View your proposal here at ' + url : ''}
          `,
          html: `<h2>UPDATE FROM DARTBID</h2>
          <p>Customer '${proposal?.info?.firstName || proposal?.info?.lastName ? proposal?.info?.firstName + ' ' + proposal?.info?.lastName : ''}' has signed their proposal.</p>
          ${proposal?.price ? '<p><strong>Total: $' + proposal?.price.toFixed(2) + '</strong></p>' : ''}
          ${url ? '<p><a href="' + url + '">View your proposal here</a></p>' : ''}
          <p>Please do not reply to this message.</p>
          `
          }).toPromise()
        } catch(err) {
          console.log(`error: ${err}`)
          return false
        }
      }
    })
  }

  notifyAdminsOfProposalSign(proposal, consultant) {
    const textMessageFunction = this.functions.httpsCallable('textMessage');
    const sendEmailFunction = this.functions.httpsCallable('sendEmail');
    const url = `${window.location.origin}/dartboard/all/${proposal?.meta?.id}`

    this.brandingService.branding$.pipe(take(1)).subscribe( async branding => {
      if (branding.company?.adminCell) {
        try {
          await textMessageFunction(
            {
              to : this.formatPhoneNumber(branding.company.adminCell),
              body: `UPDATE FROM DARTBID: Customer '${proposal?.info?.firstName || proposal?.info?.lastName ? proposal?.info?.firstName + ' ' + proposal?.info?.lastName : ''}' has signed their proposal.
                
Consultant: ${consultant?.displayName || consultant?.firstName + ' ' + consultant?.lastName}
${proposal?.price ? 'Total: ' + proposal?.price.toFixed(2) : ''}

${url ? 'View this proposal at ' + url : ''}
                `
            }
          ).toPromise()
        } catch(err) {
          console.log(`error: ${err}`)
          return false
        }
      }
      if (branding?.company?.additionalCells?.length) {
        branding?.company?.additionalCells.forEach(async number => {
          try {
            await textMessageFunction(
              {
                to : this.formatPhoneNumber(number),
                body: `UPDATE FROM DARTBID: Customer '${proposal?.info?.firstName || proposal?.info?.lastName ? proposal?.info?.firstName + ' ' + proposal?.info?.lastName : ''}' has signed their proposal.
                
Consultant: ${consultant?.displayName || consultant?.firstName + ' ' + consultant?.lastName}
${proposal?.price ? 'Total: ' + proposal?.price.toFixed(2) : ''}

${url ? 'View this proposal at ' + url : ''}
                `
              }
            ).toPromise()
          } catch(err) {
            console.log(`error: ${err}`)
            return false
          }
        });
      }
      // Check for additional emails of other admins and send them an email
      if (branding?.company?.additionalEmails?.length) {
        branding?.company?.additionalEmails.forEach(async email => {
          try {
            await sendEmailFunction({
              to: email,
              subject: `Update from Dartbid - Consultant: ${consultant?.displayName || consultant?.firstName + ' ' + consultant?.lastName}`,
              text: `Customer '${proposal?.info?.firstName || proposal?.info?.lastName ? proposal?.info?.firstName + ' ' + proposal?.info?.lastName : ''}' has signed their proposal.

Consultant: ${consultant?.displayName || consultant?.firstName + ' ' + consultant?.lastName}
${proposal?.price ? 'Total: ' + proposal?.price.toFixed(2) : ''}

${url ? 'View this proposal at ' + url : ''}
              `
            }).toPromise()
          } catch(err) {
            console.log(`error: ${err}`)
            return false
          }
        });
      }
    })
  }

  notifyAdminsOfLinkedProposalSign(proposal, consultant, total) {
    const textMessageFunction = this.functions.httpsCallable('textMessage');
    const sendEmailFunction = this.functions.httpsCallable('sendEmail');
    const url = `${window.location.origin}/dartboard/all/${proposal?.meta?.id}`

    this.brandingService.branding$.pipe(take(1)).subscribe( async branding => {
      if (branding.company?.adminCell) {
        try {
          await textMessageFunction(
            {
              to : this.formatPhoneNumber(branding.company.adminCell),
              body: `UPDATE FROM DARTBID: Customer '${proposal?.info?.firstName || proposal?.info?.lastName ? proposal?.info?.firstName + ' ' + proposal?.info?.lastName : ''}' has signed their proposal.
                
Consultant: ${consultant?.displayName || consultant?.firstName + ' ' + consultant?.lastName}
${total ? 'Total: ' + total.toFixed(2) : ''}
                `
            }
          ).toPromise()
        } catch(err) {
          console.log(`error: ${err}`)
          return false
        }
      }
      if (branding?.company?.additionalCells?.length) {
        branding.company?.additionalCells.forEach(async number => {
          try {
            await textMessageFunction(
              {
                to : this.formatPhoneNumber(number),
                body: `UPDATE FROM DARTBID: Customer '${proposal?.info?.firstName || proposal?.info?.lastName ? proposal?.info?.firstName + ' ' + proposal?.info?.lastName : ''}' has signed their proposal.
                
Consultant: ${consultant?.displayName || consultant?.firstName + ' ' + consultant?.lastName}
${total ? 'Total: ' + total.toFixed(2) : ''}
                `
              }
            ).toPromise()
          } catch(err) {
            console.log(`error: ${err}`)
            return false
          }
        });
      }
      // Check for additional emails of other admins and send them an email
      if (branding?.company?.additionalEmails?.length) {
        branding?.company?.additionalEmails.forEach(async email => {
          try {
            await sendEmailFunction({
              to: email,
              subject: `Update from Dartbid - Consultant: ${consultant?.displayName || consultant?.firstName + ' ' + consultant?.lastName}`,
              text: `Customer '${proposal?.info?.firstName || proposal?.info?.lastName ? proposal?.info?.firstName + ' ' + proposal?.info?.lastName : ''}' has signed their proposal.

Consultant: ${consultant?.displayName || consultant?.firstName + ' ' + consultant?.lastName}
${proposal?.price ? 'Total: ' + proposal?.price.toFixed(2) : ''}

${url ? 'View this proposal at ' + url : ''}
              `
            }).toPromise()
          } catch(err) {
            console.log(`error: ${err}`)
            return false
          }
        });
      }
    })
  }

  formatPhoneNumber(number:string) {
    let primary = number.replace(/[-()' ']/g,"");
    return `+1${primary}`
  }
}
